import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

import { Breakpoint, Color, FontWeight, ZIndex } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { ArtworkContainer } from '../artworkBoxes';
import { BasketSummary } from '../basketSummary/basketSummary.component';
import { ChooseBox } from '../chooseBox/chooseBox.component';

import { ContainerProps } from './basketSidePanel.types';

export const BasketSidePanelWrapper: StyledComponent<'div'> = styled.div``;

export const Container: StyledComponent<'div', ContainerProps> = styled.div<ContainerProps>`
  min-height: 100vh;
  height: 100%;
  max-width: 480px;
  width: 100%;
  background-color: ${Color.Gray200};
  position: fixed;
  top: 0;
  right: 0;
  transition: 0.3s;
  display: flex;
  flex-direction: column;
  z-index: ${ZIndex.BasketSidePanel};  
  overflow-y: auto;
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    width: 0;
  }

  ${({ $isExpanded }: ContainerProps): FlattenSimpleInterpolation => $isExpanded ? css`
    opacity: 1;
    pointer-events: initial;
  ` : css`
    transform: translate3d(100%, 0, 0);
    opacity: 0;
    pointer-events: none;
  `}
`;

export const EmptyCartContainer: StyledComponent<'div'> = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  font-weight: ${FontWeight.Medium};
  line-height: 28px;
  letter-spacing: -0.01em;
  color: ${Color.Black};
`;

export const IconContainer: StyledComponent<'div'> = styled.div`
  width: 100px;
  height: 100px;
  border: 1px solid ${Color.Gray300};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
`;

export const CloseButton: StyledComponent<'button'> = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
`;

export const CartContainer: StyledComponent<'div'> = styled.div`
  min-height: 100%;
  width: 100%;
`;

export const CartInnerContainer: StyledComponent<'div'> = styled.div`
  min-height: 100%;
  padding: 76px 20px 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Title: StyledComponent<'div'> = styled.div`
  font-size: 22px;
  font-weight: ${FontWeight.Medium};
  line-height: 28px;
`;

export const StyledArtworkContainer: StyledComponent<typeof ArtworkContainer> = styled(ArtworkContainer)`
  padding: 24px 0;

  & + & {
    border-top: 1px solid ${Color.Gray300};
  }
`;

export const ItemsContainer: StyledComponent<'div'> = styled.div`
  margin: 24px auto;
  border-top: 1px solid ${Color.Gray300};
  border-bottom: 1px solid ${Color.Gray300};
`;

export const DiscountContainer: StyledComponent<'div'> = styled.div`
  display: flex;
`;

export const ApplyButtonContainer: StyledComponent<'div'> = styled.div`
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ApplyButton: StyledComponent<'button'> = styled.button`
  font-size: 14px;
  font-weight: ${FontWeight.Medium};
  line-height: 18px;
  text-decoration-line: underline;
  color: ${Color.Gray500};
  margin-left: 16px;
`;

export const DetailsContainer: StyledComponent<'div'> = styled.div`
`;

export const SummaryContainer: StyledComponent<'div'> = styled.div`
  margin-top: 24px;

  @media ${Breakpoint.Mobile} {
    margin-bottom: 40px;
  }
`;

export const StyledBasketSummary: StyledComponent<typeof BasketSummary> = styled(BasketSummary)`
  margin-bottom: 32px;
`;

export const StyledChooseBox: StyledComponent<typeof ChooseBox> = styled(ChooseBox)`
  & + & {
    margin-top: 12px;
  }
`;

export const DiscountCodesContainer: StyledComponent<'div'> = styled.div`
  margin-top: 12px;
  display: flex;
  flex-direction: column;
`;
